import { render, staticRenderFns } from "./DadosBasicos.vue?vue&type=template&id=41dd6e04"
import script from "./DadosBasicos.vue?vue&type=script&lang=js"
export * from "./DadosBasicos.vue?vue&type=script&lang=js"
import style0 from "./DadosBasicos.vue?vue&type=style&index=0&id=41dd6e04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports